import { c as _c } from "react/compiler-runtime";
import { Icon, IconType } from "@/components/formatters/MXPIcon";
import isExternalLink from "../../utils/isExternalLink";
export interface IconTextDumpling {
  iconMachineName?: IconType;
  header?: string;
  description?: string;
  destination?: string;
  isIconVisible?: boolean;
  isDarkTheme?: boolean;
  LinkComponent?: any;
}
const baseLinkClasses = "block max-w-[280px] px-8 py-[45px] no-underline hover:no-underline focus:no-underline text-inherit text-left cursor-pointer rounded-lg";
export const IconTextDumpling = t0 => {
  const $ = _c(25);
  const {
    iconMachineName,
    header,
    description,
    destination,
    isIconVisible,
    isDarkTheme,
    LinkComponent
  } = t0;
  const linkClasses = `${baseLinkClasses} ${isDarkTheme ? "hover:bg-blue-navy" : "hover:bg-gray-m2"}`;
  let t1;
  if ($[0] !== iconMachineName || $[1] !== isIconVisible) {
    t1 = () => {
      if (iconMachineName && isIconVisible != false) {
        return <Icon type={iconMachineName} size={54} className="mb-6" />;
      }
      return null;
    };
    $[0] = iconMachineName;
    $[1] = isIconVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const renderDumplingIcon = t1;
  let t2;
  if ($[3] !== header) {
    t2 = withUnderline => {
      if (!header) {
        return null;
      }
      return <div className="mb-2"><div className={`font-bold text-xl leading-snug inline ${withUnderline ? "shadow-[inset_0_-3px_var(--color-yellow-m10)]" : ""}`}>{header}</div></div>;
    };
    $[3] = header;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const renderHeader = t2;
  let t3;
  if ($[5] !== description) {
    t3 = () => {
      if (!description) {
        return null;
      }
      return <div className="font-normal text-base leading-relaxed">{description}</div>;
    };
    $[5] = description;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const renderDescription = t3;
  let t4;
  if ($[7] !== LinkComponent || $[8] !== destination || $[9] !== linkClasses || $[10] !== renderDescription || $[11] !== renderDumplingIcon || $[12] !== renderHeader) {
    t4 = () => {
      if (LinkComponent) {
        return <LinkComponent className={linkClasses} href={destination} target={isExternalLink(destination) ? "_blank" : "_self"} rel={isExternalLink(destination) ? "noopener noreferrer" : undefined}>{renderDumplingIcon()}{renderHeader(true)}{renderDescription()}</LinkComponent>;
      } else {
        return <a className={linkClasses} href={destination} target={isExternalLink(destination) ? "_blank" : "_self"} rel={isExternalLink(destination) ? "noopener noreferrer" : undefined}>{renderDumplingIcon()}{renderHeader(true)}{renderDescription()}</a>;
      }
    };
    $[7] = LinkComponent;
    $[8] = destination;
    $[9] = linkClasses;
    $[10] = renderDescription;
    $[11] = renderDumplingIcon;
    $[12] = renderHeader;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const displayLinkDumpling = t4;
  let t5;
  if ($[14] !== destination || $[15] !== displayLinkDumpling) {
    t5 = destination && destination !== "" && displayLinkDumpling();
    $[14] = destination;
    $[15] = displayLinkDumpling;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== destination || $[18] !== renderDescription || $[19] !== renderDumplingIcon || $[20] !== renderHeader) {
    t6 = (!destination || destination === "") && <div className="max-w-[280px] px-8 py-[45px]">{renderDumplingIcon()}{renderHeader(false)}{renderDescription()}</div>;
    $[17] = destination;
    $[18] = renderDescription;
    $[19] = renderDumplingIcon;
    $[20] = renderHeader;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};